import * as API from '@/api'
import DEFINES from '@/defines'
import {getField, updateField} from 'vuex-map-fields';
//initial state
function initialState() {
    return {

    }
}
const state = initialState()

// actions

const actions = {

    async list(context,payload) {
        var response = await API.adminFilm.list(payload)
        return response;
    },
    async getFilmListByCompany(context,payload) {
        var response = await API.adminFilm.getFilmListByCompany(payload)
        return response;
    },
}


//getters

const getters = {
    getField,
}


// mutations
const mutations = {
    updateField,
    reset(state) {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
